import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { ArtistChip } from "./ArtistChip";

/** Debounced RGM artist search by name / @username (never email). */
export const ArtistSearch = ({ projectId, onPick, busy }) => {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return undefined; }
    let cancelled = false;
    const t = setTimeout(async () => {
      try {
        const r = await api.get("/studio/artists/search", { params: { q, project_id: projectId } });
        if (!cancelled) setResults(r.data?.users || []);
      } catch { if (!cancelled) setResults([]); }
    }, 300);
    return () => { cancelled = true; clearTimeout(t); };
  }, [q, projectId]);

  const pick = async (u) => {
    const ok = await onPick(u);
    if (ok) setResults((rs) => rs.map((x) => (x.user_id === u.user_id ? { ...x, invite_status: "pending" } : x)));
  };

  return (
    <div>
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search artist name or @username"
        className="w-full bg-black/40 border border-white/15 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-fuchsia-400/70"
        data-testid="collab-search-input" />
      {results.length > 0 && (
        <ul className="mt-2 space-y-1" data-testid="collab-search-results">
          {results.map((u) => {
            const st = u.invite_status;
            const locked = st === "pending" || st === "accepted";
            return (
              <li key={u.user_id} className="flex items-center gap-2 p-2 rounded-lg bg-black/30 border border-white/10">
                <span className="flex-1 min-w-0"><ArtistChip profile={u} /></span>
                <button type="button" disabled={busy || locked} onClick={() => pick(u)}
                  className="shrink-0 h-8 px-3 rounded-full bg-fuchsia-600 text-white text-[11px] font-bold disabled:bg-white/10 disabled:text-gray-400 active:scale-95 transition-transform"
                  data-testid={`collab-invite-${u.user_id}`}>
                  {st === "pending" ? "Invited" : st === "accepted" ? "Collaborator" : "Invite to Collaborate"}
                </button>
              </li>
            );
          })}
        </ul>
      )}
      {q.trim().length >= 2 && results.length === 0 && (
        <p className="mt-2 text-[11px] text-gray-500" data-testid="collab-search-empty">No artists found.</p>
      )}
    </div>
  );
};

export default ArtistSearch;
